import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { services } from '../utilities/services';
import { ServicesPageSEO } from '../../SeoTags';

const Services: React.FC = () => {
    const [activeService, setActiveService] = useState(services[0].id);

    return (
        <>
        <ServicesPageSEO />
        <div className="min-h-screen bg-gray-50">
            {/* Landing Section */}
            <div className="relative bg-darkbrown text-white py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Services</h1>
                    <p className="text-lg md:text-xl max-w-2xl opacity-90">
                        Expert surgical care and advanced treatments for various gastrointestinal and hepatobiliary conditions.
                    </p>
                </div>
            </div>

            {/* Services Content */}
            <div className="container mx-auto px-4 py-12">
                <div className="flex flex-col md:flex-row gap-8">
                    {/* Left Navigation */}
                    <div className="md:w-1/4">
                        <div className="bg-white rounded-lg shadow-md p-4">
                            <h2 className="text-xl font-semibold text-darkbrown mb-4">Our Treatments</h2>
                            <nav className="space-y-2">
                                {services.map((service) => (
                                    <button
                                        key={service.id}
                                        onClick={() => setActiveService(service.id)}
                                        className={`w-full text-left px-4 py-2 rounded-md transition-colors duration-200 ${
                                            activeService === service.id
                                                ? 'bg-brown text-white'
                                                : 'text-darkbrown hover:bg-gray-100'
                                        }`}
                                    >
                                        {service.title}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>

                    {/* Right Content - Service Cards */}
                    <div className="md:w-3/4">
                        <div className="grid md:grid-cols-2 gap-6">
                            {services.map((service) => (
                                <div
                                    key={service.id}
                                    className={`bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:shadow-lg ${
                                        activeService === service.id ? 'ring-2 ring-brown' : ''
                                    }`}
                                >
                                    <div className="h-48 overflow-hidden">
                                        <img
                                            src={service.imageUrl}
                                            alt={service.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <div className="p-6">
                                        <h3 className="text-xl font-semibold text-darkbrown mb-2">
                                            {service.title}
                                        </h3>
                                        <p className="text-gray-600 mb-4 line-clamp-3">
                                            {service.description}
                                        </p>
                                        <Link
                                            to={`/services/${service.id}`}
                                            className="inline-flex items-center text-brown hover:text-darkbrown transition-colors duration-200"
                                        >
                                            Learn More
                                            <ChevronRight className="ml-1 h-4 w-4" />
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default Services;